(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tes-about"] && !Shopify.designMode) return;
  try {
    
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const running = new Map();
  const format = (el, value) => (el.dataset.counterGrouping === 'true' ? value.toLocaleString('en-US') : String(value)) + (el.dataset.counterSuffix || '');
  const finish = (el) => {
    if (running.has(el)) cancelAnimationFrame(running.get(el));
    running.delete(el);
    el.textContent = format(el, Number(el.dataset.tesCounter));
    el.dataset.counterState = 'complete';
    el.style.setProperty('--count-progress', '1');
  };
  const start = (el) => {
    if (motion.matches) { finish(el); return; }
    const target = Number(el.dataset.tesCounter);
    if (!Number.isFinite(target)) return;
    el.dataset.counterState = 'running';
    const started = performance.now() + Number(el.dataset.counterDelay || 0);
    el.textContent = format(el, 0);
    const tick = (now) => {
      if (!el.isConnected || motion.matches) { finish(el); return; }
      const progress = Math.max(0, Math.min(1, (now - started) / 1900));
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = format(el, Math.round(target * eased));
      el.style.setProperty('--count-progress', String(eased));
      if (progress < 1) running.set(el, requestAnimationFrame(tick));
      else finish(el);
    };
    running.set(el, requestAnimationFrame(tick));
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      start(entry.target);
    });
  }, { threshold: 0.65 }) : null;
  const init = (root) => root.querySelectorAll('[data-tes-counter]:not([data-counter-state])').forEach(el => {
    el.dataset.counterState = 'ready';
    if (motion.matches || !observer) finish(el);
    else observer.observe(el);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-tes-counter]').forEach(el => { if (observer) observer.unobserve(el); finish(el); });
  });
  motion.addEventListener('change', () => { if (motion.matches) { if (observer) observer.disconnect(); document.querySelectorAll('[data-tes-counter]').forEach(finish); } });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tes-home"] && !Shopify.designMode) return;
  try {
    

(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  function revealSections(root) {
    if (reducedMotion.matches || !('IntersectionObserver' in window)) return;
    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('tes-reveal-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.08 });
    }
    root.querySelectorAll('[data-tes-reveal]:not(.tes-reveal-ready)').forEach((element) => {
      const bounds = element.getBoundingClientRect();
      if (bounds.top < window.innerHeight) return;
      element.classList.add('tes-reveal-ready');
      observer.observe(element);
    });
  }
  function init() { revealSections(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => revealSections(event.target));
  reducedMotion.addEventListener('change', () => {
    if (!reducedMotion.matches) return;
    if (observer) observer.disconnect();
    document.querySelectorAll('.tes-reveal-ready').forEach((element) => element.classList.add('tes-reveal-visible'));
  });
})();


(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    root.querySelectorAll('[data-tes-hero-video]:not([data-video-ready])').forEach(player => {
      const video = player.querySelector('video');
      const button = player.querySelector('button');
      if (!video || !button) return;
      player.dataset.videoReady = 'true';
      video.muted = true;
      video.controls = false;
      button.hidden = false;
      let wanted = !preference.matches;
      let visible = false;
      let pageReady = document.readyState === 'complete';
      const label = () => {
        button.textContent = video.paused ? button.dataset.videoPlay : button.dataset.videoPause;
        button.setAttribute('aria-label', button.textContent);
      };
      const sync = () => {
        if (pageReady && wanted && visible && !document.hidden) video.play().catch(label);
        else video.pause();
        label();
      };
      video.addEventListener('play', label);
      video.addEventListener('pause', label);
      button.addEventListener('click', () => { pageReady = true; wanted = video.paused; sync(); });
      const pageLoaded = () => { pageReady = true; sync(); };
      if (!pageReady) window.addEventListener('load', pageLoaded, { once: true });
      const visibility = () => sync();
      const preferenceChange = () => { if (preference.matches) { wanted = false; sync(); } };
      document.addEventListener('visibilitychange', visibility);
      preference.addEventListener('change', preferenceChange);
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.1 }) : null;
      if (observer) observer.observe(player);
      else { visible = true; sync(); }
      const unload = event => {
        if (!event.target.contains(player)) return;
        video.pause();
        window.removeEventListener('load', pageLoaded);
        if (observer) observer.disconnect();
        document.removeEventListener('visibilitychange', visibility);
        preference.removeEventListener('change', preferenceChange);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      label();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
